import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogModule,
} from '@angular/material/dialog';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CommonUtilService } from '../../services/common-util/common-util.service';
import { KeywordSearchRequest } from '../../services/raintree/interfaces/keyword-search';
import { KeywordSearchService } from '../../services/raintree/Transmission/keyword-search.service';
import { SnackbarService } from '../../services/common/snackbar.service';
import { SerialNoCellComponent } from '../../table-cell/serial-no-cell.component';
import { StatusResolverService } from '../../services/raintree/Transmission/status-resolver.service';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { DpBottomSheetCloserComponent } from "../../common-component/dp-bottom-sheet-closer/dp-bottom-sheet-closer.component";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SearchStatusPopupComponent } from '../search-status-popup/search-status-popup.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { SearchService } from '../../services/common/search.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-keyword-mobile-view-popup',
  standalone: true,
  imports: [InfiniteScrollModule, LoaderComponent, FormsModule, ReactiveFormsModule, MatDialogModule, DpBottomSheetCloserComponent, MatTooltipModule,
    ClipboardModule
  ],
  templateUrl: './keyword-mobile-view-popup.component.html',
  styleUrl: './keyword-mobile-view-popup.component.scss',
})
export class KeywordMobileViewPopupComponent implements OnInit {
  isLoading: boolean = false;
  searchReq = new FormControl('')
  tempData: any
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private dialog: MatDialog,
    private getstatusservice: StatusResolverService,
    private bottomSheetRef: MatBottomSheetRef<KeywordMobileViewPopupComponent>,
    private isMobile: CommonUtilService,
    private keywordSearchService: KeywordSearchService,
    private snackbar: SnackbarService,
    private _bottomSheet: MatBottomSheet,
    private _searchService: SearchService
  ) { }
  callApiService() {
    this.getstatusservice.getStatusData().subscribe({
      next: (response: any) => {
        this.statusArray = response.data;
      },
      error: (error: any) => { },
    });
  }
  ngOnInit() {
    this.loadMoreData(true);
    this.callApiService();
    this.searchReq.valueChanges.subscribe((value: any) => {
      this.datatable = this.tempData;
      if (value.length > 0) this.onSearch(value);
      else this.datatable = this.tempData;
    });
  }
  public datatable: any = [];
  public pageNo = 1;
  public pageSize = 200;
  public isLoader: boolean = false;
  private statusArray: any = [];
  columnConfs = {
    memberStatus: { cssClass: 'memberStatuswidth' },
    pincode: { cssClass: 'pincodewidth' },
  };

  cellComponentMap = {
    slNo: SerialNoCellComponent,
  };
  loadMoreData(isStart: boolean) {
    if (isStart) {
      this.datatable = [];
      this.pageNo = 1;
      this.isLoader = true;
      this.isLoading = true;
    } else {
      this.pageNo += 1;
    }

    let keywordSearchpayload: KeywordSearchRequest = {
      state_name: this.data.keywordSearchpayload.state_name,
      district_name: this.data.keywordSearchpayload.district_name,
      firstName: this.data.keywordSearchpayload.firstName,
      lastName: this.data.keywordSearchpayload.lastName,
      middleName: this.data.keywordSearchpayload.middleName,
      guardian_first_name: this.data.keywordSearchpayload.guardian_first_name,
      guardian_middle_name: this.data.keywordSearchpayload.guardian_middle_name,
      guardian_last_name: this.data.keywordSearchpayload.guardian_last_name,
      rc:this.data.keywordSearchpayload.rc,
      ritwiki_first_name: this.data.keywordSearchpayload.ritwiki_first_name,
      ritwiki_middle_name: this.data.keywordSearchpayload.ritwiki_middle_name,
      ritwiki_last_name: this.data.keywordSearchpayload.ritwiki_last_name,
      mship_date: this.data.keywordSearchpayload.mship_date,
      pinCode: this.data.keywordSearchpayload.pinCode,
      address: this.data.keywordSearchpayload.address,
      pageNo: this.pageNo,
      pageSize: this.pageSize,
    };

    this.keywordSearchService.getSearchData(keywordSearchpayload).subscribe({
      next: (response: any) => {
        if (
          response?.data?.memberList != null ||
          response?.data?.memberList != undefined
        ) {
          this.isLoader = false;
          this.isLoading = false;

          this.datatable = this.tempData = [
            ...this.datatable,
            ...response?.data?.memberList.map((user: any) => {
              this.statusArray.filter((elm: any) => {
                if (elm.status_code == user.rs) {
                  user.rs = elm.status_desc;
                }
              });
              return {
                mk: user.mk,
                fullName: user.fn + ' ' + user.ln,
                dn: user.dn,
                rs: user.rs,
                guardianName: user.gfn + ' ' + user.gln,
                md: user.md,
                rn: user.rn,
                pn: user.pn,
                add: user.add,
                st: user.st,
              };
            }),
          ];

        } else if (isStart) {
          this.isLoader = false;
          this.isLoading = false;
          this.snackbar.snackbar('Nothing to show', 'ok', 'success-snackbar');
        }
      },
      error: (error: any) => {
        this.isLoader = false;
        this.isLoading = false;
        this.snackbar.snackbar(error, 'ok', 'success-snackbar');
      },
    });
  }
  onSearch(value: any) {
    this.datatable = this._searchService.filterData(
      this.datatable,
      value,
      this.data.displayColumnData
    );
  }
  checkNull(value: any) {
    if (value && value !== "null" && value !== null && value !== undefined) {
      return value;
    } else {
      return "-"
    }
  }
  closedialog() {
    this.bottomSheetRef.dismiss();
  }
  onMKClick(event: any, tooltip: any) {
    event?.stopPropagation()
    tooltip.show()
  }
  onClickRowData(event: any) {
    this.keywordSearchService
      .getSlDetails(event.mk, { state: event.st })
      .subscribe({
        next: (response) => {
          if (!response.error && response.data.length == 1) {
            this.dialog.open(SearchStatusPopupComponent, {
              data: { data: response.data[0], status: event.rs },
            });
          }
        },
        error: (error) => {
          // this.toaster.error(error);
          this.snackbar.snackbar(error, 'ok', 'error-snackbar');
        },
      });
  }
}
